import { Spinner, Text, InlineStack } from '@shopify/polaris';

const LoadingSpinner = ({ statusText, size }) => {
  return(
    <InlineStack>
      <Spinner size={size} accessibilityLabel={statusText || ''} />
      <Text as="span" tone="subdued"> { statusText || '' }</Text>
    </InlineStack>
  )
}

export default LoadingSpinner;
